import React from 'react'
import {
  getWorldCup2026TeamFlag,
  isWorldCup2026League,
} from '../constants/worldCup2026TeamFlags'

interface TeamNameWithFlagProps {
  teamName: string
  league: string | null | undefined
  side: 'home' | 'away'
  className?: string
  nameClassName?: string
  flagClassName?: string
}

const TeamNameWithFlag: React.FC<TeamNameWithFlagProps> = ({
  teamName,
  league,
  side,
  className = '',
  nameClassName = '',
  flagClassName = 'text-lg sm:text-xl leading-none flex-shrink-0',
}) => {
  const flag = isWorldCup2026League(league) ? getWorldCup2026TeamFlag(teamName) : null

  if (!flag) {
    return <span className={className || nameClassName}>{teamName}</span>
  }

  const nameEl = (
    <span className={`truncate min-w-0 ${nameClassName}`}>{teamName}</span>
  )
  const flagEl = (
    <span className={flagClassName} aria-hidden>
      {flag}
    </span>
  )

  return (
    <span
      className={`inline-flex items-center justify-center gap-1.5 max-w-full ${className}`}
    >
      {side === 'away' ? (
        <>
          {flagEl}
          {nameEl}
        </>
      ) : (
        <>
          {nameEl}
          {flagEl}
        </>
      )}
    </span>
  )
}

export default TeamNameWithFlag
